module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/components/Leaderboard/images/footer-divider.58b96321.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/components/Leaderboard/images/footer-divider.png
// module id = 2813
// module chunks = 11